import { ElementDetails } from "@/lib/types";

export const details = {
  name: "ProfileSelector",
  description: "Select a profile",
  category: "User",
  grid: {},
  defaultProps: {},
} as ElementDetails;
